/**
 * Exception for validation errors performed by the common ValidatorsObj / Validators code.
 *
 * This was added to support providing a nullable error message to callers on failure.
 * The standard Error class requires an error string, and null or undefined values get
 * coerced to a string value. Our current handling code that puts in a default error
 * message relies on the message to be "falsy" to use the default value.
 */
export class ValidationError extends Error {
    readonly msg?: string | null;

    constructor(msg?: string | null) {
        super(`Validation failure: msg=${msg}`);
        this.msg = msg;
    }

    // Needed to allow standard logging to show the class name
    get name() {
        return this.constructor.name;
    }
}
